import { render, staticRenderFns } from "./PageInfo.vue?vue&type=template&id=2f1fed1d&scoped=true"
import script from "./PageInfo.vue?vue&type=script&lang=ts"
export * from "./PageInfo.vue?vue&type=script&lang=ts"
import style0 from "./PageInfo.vue?vue&type=style&index=0&id=2f1fed1d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1fed1d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f1fed1d')) {
      api.createRecord('2f1fed1d', component.options)
    } else {
      api.reload('2f1fed1d', component.options)
    }
    module.hot.accept("./PageInfo.vue?vue&type=template&id=2f1fed1d&scoped=true", function () {
      api.rerender('2f1fed1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/PageInfo.vue"
export default component.exports